import { Box, Grid, Paper, useMediaQuery, useTheme } from "@mui/material"
import { BackgroundGradientAnimation } from "../../components"
import { Outlet, useLocation } from "react-router-dom"
import { useEffect, useRef, useState } from "react";

export const AuthSectionLayout = () => {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const location = useLocation()
  useEffect(() => {
    const checkOverflow = () => {
      if (contentRef.current) {
        const hasOverflow = contentRef.current.scrollHeight > contentRef.current.clientHeight;
        setIsOverflowing(hasOverflow);
      }
    };
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, []);

  useEffect(() => {
    const checkOverflow = () => {
      if (contentRef.current) {
        const hasOverflow = contentRef.current.scrollHeight > contentRef.current.clientHeight;
        setIsOverflowing(hasOverflow);
      }
    };
    checkOverflow();
  }, [location]);
  const theme = useTheme()
  const isSm = useMediaQuery(theme.breakpoints.down('md'))
  return <>
    <BackgroundGradientAnimation />
    <Box
      ref={contentRef}
      style={{
        padding: theme.spacing(2),
        display: isOverflowing ? 'block' : 'flex',
        alignItems: 'center',
        height: '100vh',
        overflowY: 'auto',
        justifyContent: 'center',
      }}>
      <Paper elevation={5} sx={{
        display: 'flex',
        alignItems: 'center',
        borderRadius: theme.shape.borderRadius,
        minHeight: isSm ? undefined : '60vh',
      }}>
        <Grid container spacing={3} style={{
          padding: theme.spacing(3),
        }}>
          <Grid item xs={12}>
            <Box display="flex" justifyContent='center'>
              <img src="/logo_veles.png" alt="logo" style={{
                minWidth: isSm ? '150px' : '200px',
                maxWidth: '100%'
              }} />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{
              maxHeight: '100%'
            }} >
              <Outlet />
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box >
  </>
}
